import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useCurrentUser } from '@/app/providers/user';

// Wrap INSIDE RequireUser (this doesn't handle the loading/unauthenticated
// states itself — RequireUser already does). Non-admins are bounced to the
// home page: this is a UI-level gate only, the real enforcement is
// require_admin_user on every admin API call, which a hidden/removed nav item
// alone can't guarantee.
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { user } = useCurrentUser();
  if (user?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
